import React, { Component } from "react";

import MyRepresentative from "../containers/MyRepresentative";

class TopBar extends Component {
    render() {
        return <MyRepresentative />;
    }
}

export default TopBar;
